var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-container"},[(_vm.qrLink)?_c('img',{staticClass:"download-img",staticStyle:{"width":"500px","heigth":"500px"},attrs:{"src":_vm.qrLink,"alt":"qr_code_url"}}):_c('p',[_vm._v(_vm._s(_vm.$t('basics.qr_code_error')))])])}
var staticRenderFns = []

export { render, staticRenderFns }